/**
 * PageSpinner — Suspense fallback for lazy-loaded routes.
 *
 * Custom non-Shadcn component (kept per RESEARCH.md). Reskinned to brand
 * tokens in Plan 02-04: bg-background backdrop, text-primary spinner.
 */
export function PageSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background text-primary">
      <div className="size-8 border-2 border-primary/30 border-t-primary rounded-full animate-spin" />
    </div>
  );
}
